import React from "react";

import classes from "./TextInput.module.css";

const TextInput = ({ as: Component, className, ...props }) => (
  <Component
    className={[className, classes.numberInput].join(" ")}
    {...props}
  />
);

TextInput.defaultProps = {
  as: "input",
};

export default TextInput;
